import { z } from 'zod';
import { postRequest } from './amplify/helpers';
import { StandaloneMediaAsset } from '@/types/media';
import { StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';

export enum AICreationType {
  mediaAsset = 'mediaAsset',
  studioVideo = 'studioVideo',
}

export type BaseAICreation = {
  id: string;
  type: AICreationType;
};

export type MediaAssetAICreation = BaseAICreation & {
  type: AICreationType.mediaAsset;
  item: StandaloneMediaAsset;
};

export type StudioVideoAICreation = BaseAICreation & {
  type: AICreationType.studioVideo;
  item: StudioVideo;
};

export type AICreation = MediaAssetAICreation | StudioVideoAICreation;

export type ListAiCreationsResponse = {
  items: AICreation[];
  nextCursor: number;
};

export const ListAICreationsSchema = z.object({
  appKey: z.string(),
  cursor: z.number().optional(),
  size: z.number().optional(),
});
export type ListAICreationsRequest = z.infer<typeof ListAICreationsSchema>;

export const listAiCreations = async (request: ListAICreationsRequest): Promise<ListAiCreationsResponse> => {
  return await postRequest({
    apiName: 'studio',
    path: '/ai-creations/list',
    options: {
      body: request,
    },
  });
};
